import List from './actions/list';
import Find from './actions/find';
import Resource from './resource';

export default class Role extends Resource {
  get resourceName() {
    return 'role';
  }

  get resourcesName() {
    return 'roles';
  }
}
// @ts-ignore
List.includeInto(Role);
// @ts-ignore
Find.includeInto(Role);
